import React, { useState, useEffect } from 'react';
import './style.css';
import http from '../../services/http-service'
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import Slider from '@mui/material/Slider';
import LockIcon from '@mui/icons-material/Lock';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import checkValidationFormAllControls from '../../constants/validation';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import debounce from 'lodash.debounce';
import { useHistory } from "react-router-dom";



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 320,
    bgcolor: 'background.paper',
    borderRadius: 1,
    p: 4,
};



function GeneralConfiguration(props) {
    const [count, setCount] = useState(0);
    const [loggedUserEmail, setLoggedUserEmail] = useState(JSON.parse(localStorage.getItem('loginUser')).email);
    const [userPassword, setUserPassword] = useState('')
    const [tableData, setTableData] = useState([])
    const [openSpinner, setOpenSpinner] = useState(false);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [isCheck, setIsCheck] = useState([]);
    const [errorDisplay, seterrorDisplay] = useState('')
    const [payFrequency, setPayFrequency] = useState('');
    const [thresholdsValue, setThresholdsValue] = useState(10);
    const [cashoutFrequency, setCashoutFrequency] = useState(10000);
    const [payDetermination, setPayDetermination] = useState('')
    // const [showInfSymbol , setShowInfSymbol] = useState(true); 
    // if(props.updateChild){
    //     getPayAttributesData();
    //     getEmployeeCashout();
    // }


    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        getPayAttributesData();
        getEmployeeCashout();
        // eslint-disable-next-line
    }, [props])
    function valuetext(value) {
        return `${value}°C`;
    }

    const handleSpinnerClose = () => {
        setOpenSpinner(false);
    };
    const handleSpinnerToggle = () => {
        setOpenSpinner(!openSpinner);
    };

    const onTrigger = (event) => {
        // if ((!payFrequency) || (!payDetermination)) {
        //     toast.error("Please select pay frequency and pay determination first!",{
            // toastId: "toastId1"
        // })
        //     return
        // }
        let data = {
            'viewSetAttrComponents': true,
            'payFrequency': payFrequency,
            'payDetermination': payDetermination,
            'fromSetAttributes': false
        }
        props.handleChildCallback(data);
        event.preventDefault();
    }

    const getEmployeeCashout = (event, page) => {
        let params = {
            "employer_code": props.employerCode,
            "page": page
        }
        handleSpinnerToggle()
        http('employer/employees_transfer_cashout_list', 'GET', '', params)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    setCount(0)
                    setCount(Math.ceil(res.count / res.page_size))
                    res.results.forEach(elem => {
                        elem['selected'] = false
                    })
                    setTableData(res.results)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId1"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const handleSelectAll = () => {
        setIsCheckAll(!isCheckAll);
        setIsCheck(tableData.map(li => li.id));
        if (isCheckAll) {
            setIsCheck([]);
        }
    };

    const blockCashoutTransfers = () => {
        if (isCheck.length === 0) {
            toast.error("Please select atleast one record.",{
                toastId: "toastId2"
              })
            return
        }
        handleSpinnerToggle()
        http('employer/user_cash_out_block_by_company/', 'PUT', isCheck)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    toast.success(res.message,{
                        toastId: "toastId3"
                      })
                    setIsCheck([])
                    setIsCheckAll(false)
                    getEmployeeCashout()
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId4"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const unblockCashoutTransfers = () => {
        if (isCheck.length === 0) {
            toast.error("Please select atleast one record.",{
                toastId: "toastId5"
              })
            return
        }
        handleSpinnerToggle()
        http('employer/user_cash_out_block_by_company/', 'POST', isCheck)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    toast.success(res.message,{
                        toastId: "toastId6"
                      })
                    setIsCheck([])
                    setIsCheckAll(false)
                    getEmployeeCashout()
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId7"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const handleThresholdsChange = (event, newValue) => {
        setThresholdsValue(newValue);
    };

    const history = useHistory();

    const verifUser = (event) => {
        event.preventDefault();
        var objValidation = {};
        objValidation = checkValidationFormAllControls(document.forms[0].elements, false, [])
        if (objValidation.valid !== false) {

            seterrorDisplay(objValidation);
            return;
        } else {
            seterrorDisplay(objValidation);
        }
        let data = {
            "email": loggedUserEmail,
            "password": userPassword,
            "employer_code": props.employerCode,
            "cash_out_thresholds": thresholdsValue
        }
        handleSpinnerToggle()
        http('employer/change_pay_cash_out_thresholds/', 'POST', data)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    // setShowInfSymbol(false)
                    toast.success(res.message,{
                        toastId: "toastId8"
                      });
                    handleClose()
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId9"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const addCashoutFrequency = debounce((event, newValue) => {
        setCashoutFrequency(newValue)
         
        let data = {
            "employer_code": props.employerCode,
            "cash_out_frequency": newValue === 5 ? 100000 : newValue
        }
        handleSpinnerToggle()
        http('employer/change_pay_cash_out_thresholds/', 'PUT', data)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    // setShowInfSymbol(false)
                    toast.success(res.message,{
                        toastId: "toastId10"
                      });
                     
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId11"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }, 500)

    const getPayAttributesData = () => {
        let data = {
            "employer_code": props.employerCode
        }

        handleSpinnerToggle()
        http('employer/employers_general_setting_check/', 'GET', '', data)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    console.log(res.data.cash_out_frequency , 'frequency')
                    setPayFrequency(res.data.pay_frequency)
                    setPayDetermination(res.data.pay_determination)
                    setThresholdsValue(res.data.cash_out_thresholds)
                    if(res.data.cash_out_frequency  && res.data.cash_out_frequency <5 ){
                        setCashoutFrequency(res.data.cash_out_frequency)
                        // setShowInfSymbol(false)
                    }else if(!res.data.cash_out_frequency ) {
                     setCashoutFrequency(5)
                    }
                    // debugger
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId12"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });

                
    }
  const  getUserId = (id) => {
    if(id){
        history.push('/user-details/'+id )
}    
    }

    return (
        <div className=''>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openSpinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ width: '100%', typography: 'body1' }}>

                <Typography variant="h2" component="h2" className='settingTabHeading'>
                    Set Pay Attributes
                </Typography>
                <Typography variant="h6" component="h6" className='settingverifyTxt'>
                    Set your company pay period i.e weekly, bi-monthly, monthly; select payroll cutoff date
                </Typography>

                <Grid container mt={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl className='ml-30'>
                            <Typography variant="h2" mt={2} component="h2" className='payrollCutoff'>
                                Pay Frequency
                            </Typography>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                            >
                                <FormControlLabel checked={payFrequency === "weekly"} value="weekly" control={<Radio />} label="Weekly"/>
                                <FormControlLabel checked={payFrequency === "bi_monthly"} value="bi_monthly" control={<Radio />} label="Bi-Monthly"/>
                                <FormControlLabel checked={payFrequency === "monthly"} value="monthly" control={<Radio />} label="Monthly"/>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl className='ml-30'>
                            <Typography variant="h2" mt={2} component="h2" className='payrollCutoff'>
                                Pay Determination
                            </Typography>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                            >
                                <FormControlLabel checked={payDetermination === "calendar_days"} value="calendar_days" control={<Radio />} label="Calendar Days" onChange={(e) => setPayDetermination(e.target.value)} />
                                <FormControlLabel checked={payDetermination === "working_days"} value="working_days" control={<Radio />} label="Working Days" onChange={(e) => setPayDetermination(e.target.value)} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} mt={2} >
                        <button className='payCutoffBtn' onClick={onTrigger}>Pay Period / Cutoff Date</button>

                    </Grid>
                </Grid>

                <Grid container mt={3}>
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h6" component="h6" className='settingverifyTxt'>
                            Set transfers/cash-out thresholds - set for all employees
                        </Typography>
                    </Grid>
                    <Grid item xs={10} sm={4} md={3}>
                        <Box sx={{ width: 230 }}>
                            <Slider aria-labelledby="track-true-slider" getAriaValueText={valuetext} value={thresholdsValue} valueLabelDisplay="auto" marks step={10} min={10} max={100} onClick={handleOpen}
                                onChange={handleThresholdsChange}
                            />
                        </Box>

                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style}>
                                <Box container component="form" noValidate autoComplete="off">
                                    <Grid>
                                        <TextField margin="normal" required fullWidth id="email" label="Email Address" name="email" autoFocus type="email"
                                            onChange={(e) => {
                                                setLoggedUserEmail(e.target.value)
                                            }}
                                        />
                                        {errorDisplay.email ? <span style={{
                                            fontSize: '14px',
                                            color: '#dc0e0e'
                                        }}>{errorDisplay.email}</span> : ''}
                                    </Grid>

                                    <Grid mt={2}>
                                        <TextField margin="normal" required fullWidth name="password" label="Password" type="password" id="password"
                                            onChange={(e) => {
                                                setUserPassword(e.target.value)
                                            }}
                                        />
                                        {errorDisplay.password ? <span style={{
                                            fontSize: '14px',
                                            color: '#dc0e0e'
                                        }}>{errorDisplay.password}</span> : ''}
                                    </Grid>

                                    <Grid mt={3} style={{ display: 'flex', justifyContent: 'end' }}>
                                        <button className='payCutoffBtn' type='button' variant="contained" onClick={verifUser}>Verify</button>
                                    </Grid>
                                </Box>
                            </Box>
                        </Modal>

                    </Grid>
                    <Grid item xs={2} sm={2} md={3}><LockIcon /></Grid>
                </Grid>

                <Grid container mt={3}>
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h6" component="h6" className='settingverifyTxt'>
                            Set transfers/cash-out frequency - set for all employees
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ width: 230 }}>
                            <Slider aria-labelledby="track-true-slider" getAriaValueText={valuetext} valueLabelFormat={(num)=>{
                                // console.log(num , 'num val')
                                if(num === 5){
                                    return "∞"
                                }else{
                                return num}
                            }} value={cashoutFrequency} valueLabelDisplay="auto" marks step={1} min={1} max={5} onChange={addCashoutFrequency} />
                        </Box>
                    </Grid>
                </Grid>

                <Typography mt={3} variant="h6" component="h6" className='settingverifyTxt'>
                    Block or stop transfers/cash-out - set for all employees or at individual level
                </Typography>
                <div className='enrollTabDiv'>
                    <Accordion defaultExpanded={true}>
                        <AccordionSummary className='accordianHeading'
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Block</Typography>
                        </AccordionSummary>
                        <AccordionDetails className='accordianDescription'>
                            {tableData.length > 0 ? (
                                <div>
                                    <div className='customTable'>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th><Checkbox size="small" onChange={handleSelectAll} name="selectAll" id="selectAll" checked={isCheckAll} />First Name </th>
                                                    <th>Last Name</th>
                                                    <th>User ID</th>
                                                    <th>Location</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    tableData.map((cell, index) => (
                                                        <tr key={index}>
                                                            <td key={cell.first_name + index}> <Checkbox size="small" id={cell.id.toString()} checked={isCheck.includes(cell.id)}
                                                                onChange={(e) => {
                                                                    cell.selected = e.target.checked
                                                                    setIsCheck([...isCheck, cell.id]);
                                                                    if (!e.target.checked) {
                                                                        setIsCheck(isCheck.filter(item => item !== cell.id));
                                                                    }
                                                                    let selectAll = tableData.filter(item => item.selected !== false)
                                                                    if (tableData.length !== selectAll.length) {
                                                                        setIsCheckAll(false)
                                                                    } else {
                                                                        setIsCheckAll(true)
                                                                    }
                                                                }}
                                                            /> {cell.first_name}  </td>
                                                            <td key={cell.last_name + index}> {cell.last_name} </td>
                                                            <td key={cell.code + index}> {cell.code} </td>
                                                            <td key={cell.location + index}> {cell.location} </td>
                                                            <td key={cell.user_status + index}><button onClick={()=>getUserId(cell.id)}className='submitBtn' style={{cursor:"auto"}}>{ cell.transfer_cashout ? "Block": cell.user_status} </button></td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>


                                    </div>
                                    <Grid container mt={1}>
                                        <Grid xs={12} md={6} mb={2}>
                                            <Stack spacing={2}  className="centerPagination">
                                                <Pagination count={count} color="primary" onChange={getEmployeeCashout} />
                                            </Stack>
                                        </Grid>
                                        <Grid xs={12} md={6} mb={2} className="sendIcon colorBlue ">
                                            <button className='btnSave bgRed cursorStyle' onClick={blockCashoutTransfers}>Block</button>
                                            <button className='btnSave ml-2 cursorStyle' onClick={unblockCashoutTransfers}>UnBlock</button>
                                        </Grid>
                                    </Grid>
                                </div>

                            ) : (
                                <div className='recordNotFoundDiv'>
                                    <h2>Records Not Found</h2>
                                </div >
                            )}

                        </AccordionDetails>
                    </Accordion>
                </div>
            </Box>
        </div>
    );
}

export default GeneralConfiguration;